import {
  putStudentProgress,
  getSonePersonalDetails,
  getStudentProgress
} from '../services/vu'
import { getCourseId } from './course'
import { getConfiguration } from './configuration'

const getDefaultStepProgress = () => {
  let defaultSteps = [
    {
      header: 'Start your enrolment',
      url: getConfiguration('baseUrl') + '/',
      submitted: false,
      disabled: false
    },
    {
      header: 'Confirm your details',
      url: getConfiguration('baseUrl') + '/confirm_details',
      submitted: false,
      disabled: true
    },
    {
      header: 'Additional details',
      url: getConfiguration('baseUrl') + '/additional_details',
      submitted: false,
      disabled: true
    },
    {
      header: 'USI details',
      url: getConfiguration('baseUrl') + '/usi_details',
      submitted: false,
      disabled: true
    },
    {
      header: 'Financial support',
      url: getConfiguration('baseUrl') + '/financial_support',
      submitted: false,
      disabled: true
    },
    {
      header: 'Enrol in your units',
      url: getConfiguration('baseUrl') + '/units',
      submitted: false,
      disabled: true
    },
    // {
    //   header: 'Submit your enrolment',
    //   url: getConfiguration("baseUrl") + '/submit',
    //   submitted: false,
    //   disabled: true
    // },
    {
      header: 'Thank You',
      url: getConfiguration('baseUrl') + '/thankyou',
      submitted: false,
      disabled: true
    }
  ]

  const hideFinancialSupportPage = isFinancialSupportHidden()
  if (hideFinancialSupportPage) {
    defaultSteps = defaultSteps.filter(step => {
      return step.header !== 'Financial support'
    })
  }

  const hideUsiStepPage = isUsiStepHidden()
  if (hideUsiStepPage) {
    defaultSteps = defaultSteps.filter(step => {
      return step.header !== 'USI details'
    })
  }

  return defaultSteps
}

const isUsiStepHidden = () => {
  const isUsiEnabled = sessionStorage.getItem('ENROL_USI_ENABLED')
  if (isUsiEnabled && isUsiEnabled === 'Y') {
    return false
  }

  return true
}

const isFinancialSupportHidden = () => {
  const isEligibleForFinancial = sessionStorage.getItem(
    'IS_ELIGIBLE_FOR_FINANCIAL'
  )
  if (isEligibleForFinancial && isEligibleForFinancial === 'N') {
    return true
  }

  return false
}

export const getStepProgress = () => {
  const stepProgress = getUnorderedStepProgress()
  // Force all the steps to be properly sorted
  return getDefaultStepProgress().map(defaultStep => {
    const step = stepProgress.find(({ url }) => defaultStep.url === url)
    if (step) {
      return {
        ...step,
        header: defaultStep.header
      }
    }
    if (
      stepProgress.filter(val => {
        return val.disabled === false
      }).length > 3 &&
      defaultStep.header === 'USI details'
    ) {
      if (defaultStep.disabled) {
        defaultStep.disabled = false
      }
    }
    return defaultStep
  })
}

//if the USI is not hidden check if it is submitted if not return true else false
export const isUSIStepSubmitted = () => {
  //is it enabled
  if (!isUsiStepHidden()) {
    var usiStepArray = getStepProgress().filter(
      step => step.header === 'USI details' && !step.submitted
    )
    if (usiStepArray.length > 0) {
      return true
    } else {
      return false
    }
  }

  return false
}

const getUnorderedStepProgress = () => {
  const stepProgressAsString = sessionStorage.getItem('steps')

  if (stepProgressAsString !== null) {
    return JSON.parse(stepProgressAsString)
  }

  const stepProgress = getDefaultStepProgress()

  sessionStorage.setItem('steps', JSON.stringify(stepProgress))

  return stepProgress
}

export const updateStepProgress = stepIndexToUpdate => {
  const newStepProgress = getStepProgress().map((step, stepIndex) => {
    // Flag the current step as "submitted" (so we can update the frontend
    // accordingly)
    if (stepIndex === stepIndexToUpdate) {
      return Object.assign({}, step, {
        submitted: true
      })
    }

    // Flag the next step as "enabled" (also so we can update the frontend
    // accordingly)
    if (stepIndex === stepIndexToUpdate + 1) {
      return Object.assign({}, step, {
        disabled: false
      })
    }

    return step
  })

  sessionStorage.setItem('steps', JSON.stringify(newStepProgress))
}

export const isOnboardingCompleted = () => {
  return getStepProgress()
    .filter(step => step.url !== '/thankyou')
    .every(step => step.submitted)
}

export const setStepProgress = stepObj => {
  sessionStorage.setItem('steps', JSON.stringify(stepObj))
}

export const getStepIndexByUrl = url => {
  return getStepProgress().findIndex(step => isStepMatch(step, url))
}

export const isStepMatch = (step, url) =>
  step.url.replace(/\/+$/, '') === url.replace(/\/+$/, '')

export const getStepByIndex = stepIndex => {
  return getStepProgress()[stepIndex]
}

export const getCurrentPage = () => {
  return location.pathname + location.search
}

export const updateDBStepProgress = currentPage => {
  return getStudentProgress(getCourseId()).then(progress => {
    //get Step index from
    let url = ''
    if (!progress.currentPage) {
      url = ''
    } else {
      url = progress.currentPage
    }

    let stepIndex = getStepIndexByUrl(url)
    //Check if the current step is thank you page. If it is do not update BE
    if (stepIndex !== 7) {
      return getSonePersonalDetails().then(personalDetails => {
        return putStudentProgress(
          getCourseId(),
          personalDetails.studentId,
          currentPage || getCurrentPage(),
          getStepProgress()
        )
      })
    }
    return progress
  })
}
